import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Section';
export function Guarantee() {
  return <Section background="paper" width="narrow" labelledBy="guarantee-heading" data-id="element-163" data-mp="1o2vk0ww891a9">
      <div className="text-center" data-id="element-164" data-mp="223obf8r8fg95">
        <ShieldCheckIcon className="mx-auto h-10 w-10 text-sage" strokeWidth={1.25} aria-hidden="true" data-id="element-165" data-mp="222n0d4a7utrf" />

        <h2 id="guarantee-heading" className="mt-6 font-serif text-[27px] font-semibold leading-[1.15] text-ink sm:text-3xl lg:text-[40px]" data-id="element-166" data-mp="19e7ogqmdsrkb">
          7-day guarantee — no questions asked
        </h2>

        <p className="mt-6 font-serif text-xl font-medium italic leading-snug text-brass sm:text-2xl" data-id="element-167" data-mp="1j5c29n0bm6dk">
          Download it. Read Volume 1. Use one script in one real class.
        </p>

        <p className="mt-6 font-sans text-[17px] leading-[1.65] text-ink-soft" data-id="element-168" data-mp="qn7ufb014rk6">
          If within 7 days it isn't what you expected, we refund 100% — no forms, no hoops, no hard
          feelings. Volume 1 takes fifteen minutes to put to work, so you'll know well before the
          week is out.
        </p>
      </div>
    </Section>;
}